import { queryOptions, useQuery } from '@tanstack/react-query';

import { QueryOptions } from '@cast/shared-types';
import { DboInstanceCachingSummaryResponse } from '@cast/types-database-optimizer';

import { apiClient } from '@cast/infrastructure-api';

const apiFn = apiClient.dbo.getDatabaseInstanceCachingSummary;

export const DBO_INSTANCE_CACHING_SUMMARY_QUERY_KEY =
  'dbo-instance-caching-summary';

const getInstanceCachingSummaryQueryKey = (
  params: Parameters<typeof apiFn>[0]
) => [DBO_INSTANCE_CACHING_SUMMARY_QUERY_KEY, params] as const;

export const useInstanceCachingSummaryQuery = <
  SELECT = DboInstanceCachingSummaryResponse
>(
  params: Parameters<typeof apiFn>[0],
  options?: QueryOptions<DboInstanceCachingSummaryResponse, SELECT>
) =>
  useQuery(
    queryOptions({
      queryKey: getInstanceCachingSummaryQueryKey(params),
      queryFn: async () => {
        const { data } = await apiFn(params);
        return data;
      },
      ...options,
    })
  );
